import React from 'react';
import ReactMapGL, {Marker, NavigationControl} from 'react-map-gl'
import 'mapbox-gl/dist/mapbox-gl.css';
import ListingPin from '../map/listing_pin.js'
import Modal from 'react-modal';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"
import './detail_modal.scss';
import { formatCurrency, ShowValueWithIcon, formatAddress, featureHasNoValue, imageResize, parseJsonLikeBlob,
    formatSqFeet, convertPropType, daysListed, trackClick, decodeHtml } from '../util/util.js';
import { Bed, Bathtub, Tape, ExitLeft, Close, Share, Pin } from '../util/icons_svg.js';
import { HeartToggle } from "../util/toggle.js";
import {DetailBlock, Attribution, FeatureItem, FloorPlans, DescriptionBlock } from './detail_snippets.js';
import {BrandingAgentCommunity, BrandingBrokerManager } from './detail_branding.js';
import ContactForm from './contact_form.js';
import ListhubContactForm from './listhub_contact_form.js';
import {excludedSource, excludedProperty, leadFormCredentials} from '../util/listhub_source'

const defaults = require("../defaults.json");

const customStyles = {
    content : {
        position: "relative",
        top: 0,
        margin: "auto",
        height: "100%"
    },
    overlay : {zIndex: 20000}
};

const mapboxToken = 'pk.eyJ1IjoiYWRvYmVsaXMtYWR2IiwiYSI6ImNqcGJtdXQ0eTIydXIzd3Fza2FudDN0d2kifQ.NPIp-5FiKM9yxt57thyDfQ';

const navStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  padding: '10px'
};

class DetailModal extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef(); // access element attributes within the component
        this.reactMapWrapperRef = React.createRef();
        this.defaultConfig = defaults[this.props.affiliate.split("_")[1]];
        this.listHubProviderId = this.defaultConfig.listHubProviderId || null;
        this.state = {
            viewport: {
                height: 600,
                width: 400,
                latitude: 0,
                longitude: 0,
                zoom: 14,
            },
            allowZoom: false,
        };
    }

    enableZoom = ()=>{
        this.setState({allowZoom: true})
    }

    _renderListingMarker = (item) => {
        if (item.longitude) {
            return (
                <Marker
                    longitude={Number(item.longitude)}
                    latitude={Number(item.latitude)} >
                    <ListingPin
                        size={30}
                        text=""
                    />
                </Marker>
            );
        } else {
            return false;
        }
    }

    closeModal = () => {
        this.setState({
            viewport:{
                longitude:0,
                latitude:0,
                zoom:14},
            allowZoom:false});
        this.props.onRequestClose();
    }

    afterModalOpen = () => {
        const {item, trackingEnabled} = this.props;
        const dataProperty = item.property ? item.property.toUpperCase() : null;
        if (trackingEnabled) {
            try {
                if (item.listhub_key && this.listHubProviderId) {
                    const _lh = new window.ListHubTracker({provider: this.listHubProviderId, test: false});
                    _lh.submit('DETAIL_PAGE_VIEWED', item.listhub_key);
                }
            } catch(err) {console.log('listHub error' + err)}
            try {
                if (typeof(window._LT) !== 'undefined' &&
                    window._LT !== null &&
                    !dataProperty.includes('ADPAY') &&
                    !!item.agent_id_attribute) {
                    window._LT.initListTrac('al.com_100239');
                    window._LT._trackEvent(window._eventType.view, item.ad_number, item.zipcode, item.agent_id_attribute);
                }
            } catch(err) {console.log('listtrac error' + err)}
        }
    }

    componentDidUpdate() {
        // find the wrapping <div> for the React Map and set the tab index to -1 so it is not in the tab flow order
        // that the contact form uses
        try {
            if (this.reactMapWrapperRef && this.reactMapWrapperRef.children) {
                this.reactMapWrapperRef.children[0].setAttribute('tabindex', '-1')
            }
        } catch(e) {
            // Added try-catch here because this was erroring on modal close.
            // To do: something that doesn't try to error.
            console.log(e);
        }
    }

    render() {
        //console.log("Detail modal - props are:");
        //console.log(this.props);
        const {affiliate, fullName, item, isOpen, reportingServerPath, trackingEnabled} = this.props;
        let image_array =[];

        const mapAddress = item.internet_address
            ? item.internet_address
            : item.address
                ? item.address
                : null;
        const propertyTitle = mapAddress || convertPropType(item);
        // listingText gets inserted as raw innerHTML for client side rendering. This should not be a XSS problem,
        // because inserting innerHTML with a script tag does not execute the script tag. But we will make an effort
        // to remove script tags, regardless. If rendered on the server side, the HTML is encoded (see below).
        let listingText = (item.listing_text || item.ad_text)
        listingText = typeof listingText === 'string' && listingText.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
        const isCommunity = (item.list_type && item.list_type.toUpperCase() === 'COMMUNITY') ? true : false;
        const premier = item.premier_listing && item.premier_listing.toUpperCase() === 'ON';
        const enhancedAgent = (item.agent_marketing_level && item.agent_marketing_level.toUpperCase() === 'ENHANCED') ? true : false
        const enhancedBroker = (item.broker_marketing_level && item.broker_marketing_level.toUpperCase() === 'ENHANCED') ? true : false
        const outsideListingUrl = (!!item.showcase_home && !!item.showcase_url)
                                    ? item.showcase_url.replace('&#58;',':')
                                    : !!item.detail_url
                                        ? item.detail_url.replace('&#58;',':')
                                        : null;
        // ****** Listings not to use the Move.com Lead form ****** //
            // Any listing in a Morris Property with a DATA SOURCE TYPE: “Newspaper” 
                //(ex.AL_BHAMNEWS) or 
            // “Any listings in the following properties”
                //- this value can be found by referencing the “property” key of the payload
                //Any listings in the following specific properties: *_ADPAY, *_AGENTFINDER, *_BHI, *_BHHS, *_COLDWELL, *_HOWARDH, *_WEICHERT, AL_REALTYSOUTH, MA_MASIELLOGROUP_LH, MI_REALONE, MI_REMAX, MI_REMAXSEMI, MI_REMERICA, MI_TOMIE, NJ_LONGFOSTER_LH, NJ_REMAX, PN_JGAUGHEN, and PN_JGAUGHEN_RENT
            //Any listing either of the following exist: 
                //AD_CUSTOMER_ATTRIBUTE:
                //MARKETING_LEVEL: Enhanced,
                //AD_CUSTOMER_PARENT_ATTRIBUTE:
                //MARKETING_LEVEL: Enhanced
                    //- this refers to agent/broker marketing level.
                    //These values can be found by referencing the “agent_marketing_level” or “broker_marketing_level” keys, respectively.
                    //Values include “None”, “Basic”, and in this case, “Enhanced”
        // ****** Listings not to use the Move.com Lead form ****** //
        const checkItem = (item, checklist) => {
            return item && checklist.some(el => item.indexOf(el) >= 0);
        }
        const isResale = item.list_type === "resale";
        const isExcludedSource = checkItem(item.source_attribution, excludedSource);
        const isExcludedProperty = checkItem(item.property, excludedProperty);
        const isEnhanced = (item.agent_marketing_level && item.agent_marketing_level === 'Enhanced') || (item.broker_marketing_level && item.broker_marketing_level === 'Enhanced')
        const hasCredentials = leadFormCredentials[fullName];
        const postToMoveAPI = !hasCredentials || isExcludedSource || isExcludedProperty || isEnhanced || !isResale
            ? false
            : true;
        const showContactForm = (item.community_email || item.property_management_email || item.listing_email || item.agent_email || item.broker_email)
            ? true
            : false
        const models = item.models ? parseJsonLikeBlob(item.models) : {}
        const images = item.images ? parseJsonLikeBlob(item.images) : null
        if (images) {
            image_array = images.map(i => {return imageResize(i.image_url, 720)})
        }
        const SCHOOL_INFO = [
            {label: "School District", feature: item.school_district},
            {label: "Elementary School", feature: item.elementary_school},
            {label: "Elementary School District", feature: item.elementary_district},
            {label: "Middle School", feature: item.middle_school},
            {label: "Middle School District", feature: item.middle_school_district},
            {label: "High School", feature: item.high_school},
            {label: "High School District", feature: item.high_school_district}
        ]
        const hideSchoolInfo = SCHOOL_INFO.every( feature => featureHasNoValue(feature.feature));
        const footer = document.getElementById("footer-wrapper");
        const footerElement = footer
                                ? document.getElementById("footer-wrapper").innerHTML
                                : null;
        const reportingTrackingPath = isCommunity
                                        ? reportingServerPath + "MDAPT_SITE/" + item.source_id + ".gif?com_id=" + item.ad_id + ";mgmt_co_id=" + item.property_management_id
                                        : reportingServerPath + "MDRE_SITE/" + item.category_id + ".gif?aid=" + item.agent_id + ";bid=" + item.broker_id + ";lid=" + item.ad_id;
        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={this.closeModal}
                onAfterOpen={this.afterModalOpen}
                style={customStyles}
                className="detail-modal"
            >
                <div className="detail-modal-top-bar">

                    <a className="back-to-results" onClick={this.closeModal}>
                        <div className="exit-left-icon"><ExitLeft/></div>
                        <span>Back to results </span>
                    </a>
                    <span className="top-bar-property-title">/&nbsp;
                    {propertyTitle}
                    </span>
                    <a className="detail-modal-close" onClick={this.closeModal}><Close/></a>
                </div>
                <div className="detail-content">
                {/*<div className="offering">For {listingTypeLabel}</div>*/}
                    <div className="carousel-wrapper">
                        <div className="carousel-background"
                             style={(affiliate !== "RE_syr")
                                ? {
                                    backgroundImage: `url(${image_array[0]})`,
                                    filter: "blur(8px)"
                                }
                                : { background: "#bbb"}
                             }
                        ></div>
                        <Carousel
                            showThumbs={false}
                            showIndicators={false}
                            className="carousel-direct"
                            onChange={(idx) => {
                                if(affiliate !== "RE_syr") {
                                    const src = window.document.querySelectorAll('.carousel-slider li img')[idx].src
                                    const backgroundStyle = window.document.querySelector('.carousel-background').style;
                                    backgroundStyle.backgroundImage = `url(${src})`;
                                }
                                // TRACK: carousel_next
                                trackClick('dp_carousel_next',`next_click: ${item.ad_id}-${idx}`);
                            }}>
                            {image_array.map((n, index) => {
                                return (
                                    <div key={index}><img className="detail-image" src={n} alt="" /></div>
                                )})
                            }
                        </Carousel>
                    </div>
                    <button className="share-action"
                        onClick={() => {
                            // TRACK: dp_share_icon_click
                            trackClick('dp_share_icon_click',`share_click: ${item.ad_id}`);
                            this.props.shareClick()
                        }}
                    >
                        <Share/>
                        <div className="description">Share</div>
                    </button>
                    <HeartToggle
                        adId={item.ad_id}
                        className="heart-toggle"
                        clear={false}
                        origin="detail"
                        item={item}
                        trackingEnabled={trackingEnabled}
                    />
                    <div className="property-details">
                        <div className="alert-bar adv-clearfix">
                            <div className="property-alerts">
                                {premier &&
                                    <div className="premier-div">Premier</div>
                                }
                                {(!!item.just_listed && item.just_listed.toUpperCase() === 'ON')
                                    ? <div className="just-listed-div">Just Listed</div>
                                    : (!enhancedAgent && !enhancedBroker && !premier && !isCommunity)
                                        ? <div className="just-listed-div">Listed {daysListed(item.date_created)}</div>
                                        : null}
                                {item.showcase_home
                                    ? <div className="showcase-div">Showcase</div>
                                    : null}
                                {!!item.open_house &&
                                    <div className="open-house-div">
                                        Open House:<br />
                                        {decodeHtml(item.open_house)}
                                    </div>
                                }
                                {!!item.special_offers &&
                                    <div className="special-offers-div">
                                        Special Offer
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="details-basic-info">
                            <div className="address">
                                <div className="property-title">
                                    <div className="title-text">{propertyTitle}</div>
                                    {item.latitude
                                        ?
                                        <a
                                            className="title-map-link"
                                            onClick={() => {
                                                // TRACK: dp_map_link_click
                                                trackClick('dp_map_link_click',`map_link_click: ${item.ad_id}`);
                                                window.document.querySelector("#detail-map")
                                                    .scrollIntoView({behavior: "smooth"})
                                            }}
                                        >
                                            <div className="map-pin-pin"><Pin/></div>
                                            <div className="map-pin-text">Map</div>
                                        </a>
                                        :
                                        null
                                    }
                                </div>
                                <div className="city-state-zip">
                                    {formatAddress(item.city, item.state, item.zipcode)}
                                </div>
                            </div>
                            <div className="price">
                                <ShowValueWithIcon
                                    do_not_display_rent = {item.do_not_display_rent}
                                    list_type={item.list_type}
                                    exact={item.price}
                                    min={item.rent_min}
                                    max={item.rent_max}
                                    transform={formatCurrency}
                                />
                            </div>
                            <div className="property-dimensions">
                                <ShowValueWithIcon
                                    list_type={item.list_type}
                                    exact={item.beds}
                                    min={item.bed_min}
                                    max={item.bed_max}
                                    field='bd'
                                    icon={<Bed/>}
                                />
                                <ShowValueWithIcon
                                    list_type={item.list_type}
                                    exact={item.baths}
                                    min={item.bath_min}
                                    max={item.bath_max}
                                    field='ba'
                                    icon={<Bathtub/>}
                                />
                                <ShowValueWithIcon
                                    list_type={item.list_type}
                                    exact={item.number_sqfeet}
                                    icon={<Tape/>}
                                    transform={formatSqFeet}
                                />
                            </div>
                        </div>
                        {!!item.special_offers
                            ? <div className="details-section special-offers">
                                <h2 className="section-title">Special Offers</h2>
                                <div className="description-text">
                                    {item.special_offers}
                                </div>
                              </div>
                            : null
                        }
                        <div className="details-section details-details">
                            <h2 className="section-title">Details</h2>
                            <DetailBlock item={item} />
                        </div>
                        <div className="details-section description">
                            <h2 className="section-title">Description</h2>
                            {/* render as raw unescaped HTML *only* if running client-side; if running server-side this would (?) allow XSS. */}
                            { typeof window === 'undefined'
                                ? <div> className="description-text">
                                    {listingText}
                                  </div>
                                : <div
                                    className="description-text"
                                    dangerouslySetInnerHTML={{__html: listingText}}
                                  >
                                  </div>
                            }
                            {outsideListingUrl
                                ? <div className="showcase-see-more-link">
						            <a href={outsideListingUrl}
						                target="_new"
						                rel="noopener noreferrer"
						                onClick={() => {
                                            trackClick('dp_click_to_advertiser_site',`advertiser_site_click: ${item.ad_id}`);
                                            if (!isCommunity) {
                                                const dataProperty = item.property.toUpperCase();
                                                fetch(reportingTrackingPath + ';pc=207', {mode: 'no-cors'});
                                                fetch(reportingTrackingPath + ';pc=491', {mode: 'no-cors'});
                                                if (trackingEnabled &&
                                                    typeof(window._LT) !== 'undefined' &&
                                                    window._LT !== null &&
                                                    !dataProperty.includes('ADPAY') &&
                                                    !!item.agent_id_attribute) {
                                                    try {
                                                        window._LT._trackEvent(window._eventType.clickThrough, item.ad_number, item.zipcode, item.agent_id_attribute);
                                                    } catch(err) {console.log('listtrac error' + err)}
                                                }
                                            }
                                        }}
						                className="btn_viewlistings">
						                View Listing Website
						            </a>
                                  </div>
                                : null}
                        </div>
                        <DescriptionBlock item={item} />
                        {!hideSchoolInfo
                            ? <div className="details-section neighborhood">
                                {/*<h2>Neighborhood</h2>*/}
                                <div className="school-list">
                                    <h2>Schools</h2>
                                    <ul className="greenlist">
                                        {SCHOOL_INFO.map((feature, index) => {
                                            return (
                                                <FeatureItem key={index} label={feature.label} feature={feature.feature} />
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            : null
                        }
                        {models.map // Checking to see if models is an array
                            ? <FloorPlans
                                 models={models}
                                 floorplanClick={this.props.floorplanClick}
                                 do_not_display_rent={item.do_not_display_rent}
                              />
                            : null
                        }
                        {item.latitude
                            ? <div className="details-section map" id="detail-map">
                                <h2>Map</h2>
                                <div ref={el => (this.reactMapWrapperRef = el)} onClick={()=>{
                                            this.enableZoom()}}>
                                    <ReactMapGL
                                        {...this.state.viewport}
                                        latitude = {this.state.viewport.latitude !== 0 ? this.state.viewport.latitude : Number(item.latitude) }
                                        longitude = {this.state.viewport.longitude !== 0 ? this.state.viewport.longitude : Number(item.longitude) }
                                        width = '100%'
                                        height={window.innerWidth > 720
                                            ? 600
                                            : Math.min(window.innerWidth, 600)}
                                        mapStyle="mapbox://styles/mapbox/streets-v11"
                                        maxPitch={0}
                                        onViewportChange={(viewport) => this.setState({viewport})}
                                        scrollZoom={this.state.allowZoom}
                                        mapboxApiAccessToken = {mapboxToken}>
                                            {this._renderListingMarker(item)}
                                            <div className="nav" style={navStyle}>
                                                <NavigationControl onViewportChange={(viewport) => this.setState({viewport})} />
                                            </div>
                                    </ReactMapGL>
                                    <p className="disclaimer">
                                        This map is informational only. No representation is made or warranty given as to its accuracy or content. User assumes all risk of use.<br />
                                        {fullName}.com, Mapbox and their suppliers assume no responsibility for any loss or delay resulting from such use.
                                    </p>
                                </div>
                                </div>
                            : null}

                        <div className="details-section footnotes">
                            <Attribution item={item} />
                        </div>
                        <div className="details-section eho_wrap">
                            <a href={"https://www." + fullName + ".com/eho/"}><img src="//static.advance.net/static/classifieds/realestate/details/img/logo_eho.png" alt="" /></a>
                        </div>
                        <div className="details-section ad_wrap">
                            <div id="InContent_Center"></div>
                            <div id="RightRail_Bottom" className="right"></div>
                        </div>
                        {((isCommunity && item.source_id) || item.category_id) &&
                            <div className="tracker">
                                <img alt="" src={isCommunity ? reportingTrackingPath + ";pc=402" : reportingTrackingPath + ";pc=201"} />
                                {premier &&
                                    <img alt="" src={isCommunity ? reportingTrackingPath + ";pc=403" : reportingTrackingPath + ";pc=300"} />}
                            </div>
                        }
                        {!! footerElement &&
                            <div dangerouslySetInnerHTML={{__html: footerElement}} />
                        }
                        <div className="end-of-content"/>
                    </div>
                    <div className={`broker-agent-container ${postToMoveAPI && 'listhub-form'}`}>
                        <div className="broker-agent">
                            {!postToMoveAPI &&
                                <div className="broker-agent-contact">
                                    <BrandingAgentCommunity
                                        item={item}
                                        affiliate={affiliate}
                                        fullName={fullName}
                                        isCommunity={isCommunity}
                                        enhancedAgent={enhancedAgent}
                                    />
                                    <BrandingBrokerManager
                                        item={item}
                                        affiliate={affiliate}
                                        fullName={fullName}
                                        isCommunity={isCommunity}
                                        mapAddress={mapAddress}
                                        enhancedBroker={enhancedBroker}
                                        reportingTrackingPath={reportingTrackingPath}
                                        trackingEnabled={trackingEnabled}
                                        listHubProviderId={this.listHubProviderId}
                                    />
                                    {showContactForm && !postToMoveAPI &&
                                        <ContactForm
                                            item={item}
                                            streetAddress={propertyTitle}
                                            affiliate={affiliate}
                                            fullName={fullName}
                                            isCommunity={isCommunity}
                                            reportingTrackingPath={reportingTrackingPath}
                                            trackingEnabled={trackingEnabled}
                                            listHubProviderId={this.listHubProviderId}
                                        />
                                    }
                                    <a className="broker-agent-mobile-close" onClick={() => {
                                        window.document.querySelector('.broker-agent-container').classList.toggle('show-contact-mobile')
                                        window.document.querySelector('.broker-agent-mobile-adhesion').classList.toggle('show-contact-mobile')
                                    }}><Close/></a>
                                </div>
                            }
                            {postToMoveAPI &&
                                <div className="broker-agent-contact">
                                    <ListhubContactForm
                                        item={item}
                                        streetAddress={propertyTitle}
                                        affiliate={affiliate}
                                        fullName={fullName}
                                        reportingTrackingPath={reportingTrackingPath}
                                        trackingEnabled={trackingEnabled}
                                        listHubProviderId={this.listHubProviderId}
                                        propertyTitle={propertyTitle}
                                        postToMoveAPI={postToMoveAPI}
                                        priceRange={this.props.priceRange}
                                    />
                                    <a className="broker-agent-mobile-close" onClick={() => {
                                            window.document.querySelector('.broker-agent-container').classList.toggle('show-contact-mobile')
                                            window.document.querySelector('.broker-agent-mobile-adhesion').classList.toggle('show-contact-mobile')
                                    }}><Close/></a>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="broker-agent-mobile-adhesion"
                        onClick={() => {
                            window.document.querySelector('.broker-agent-container').classList.toggle('show-contact-mobile')
                            window.document.querySelector('.broker-agent-mobile-adhesion').classList.toggle('show-contact-mobile')
                            // TRACK: mobile adhesion click
                            trackClick('dp_mobile_ad_click',`mobile_ad_click: ${item.ad_id}`);
                        }}
                    >
                        {!postToMoveAPI && <div className="broker-agent-show-hide-contact">
                            <BrandingAgentCommunity item={item} isCommunity={isCommunity} mini={true} />
                            <BrandingBrokerManager item={item} isCommunity={isCommunity} mini={true} />
                        </div>}
                        {(!!showContactForm || postToMoveAPI)&&
                            <button className={`broker-agent-show-hide  ${postToMoveAPI && 'listhub-form'}`}>
                                {postToMoveAPI ? "Learn More" : "Contact Realtor"}
                            </button>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}


export default DetailModal;
